/* ActionItemComponent.js */

"use strict";
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./ActionItemRenderer");

class ActionItemComponent extends EventEmitter {
    constructor(iconElement, textMessage) {
        super();
        this._renderer = new Renderer(this, iconElement);
        this._message = textMessage;
        this._isDisabled = false;
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    get message(){
        return this._message;
    }
    setMessage(newText){
        this._message = newText;
        this.emit('MessageChanged');
    }
    shutdown(){
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        return prom;
    }
    itemClicked(){
        this.emit('ActionItemClicked');
    }
    hide(){
        this._isHidden = true;
        this.renderer.render();
    }
    show(){
        this._isHidden = false;
        this.renderer.render();
    }
    get isHidden(){
        return this._isHidden;
    }
    disable(){
        this._isDisabled = true;
        this.renderer.render();
    }
    enable(){
        this._isDisabled = false;
        this.renderer.render();
    }
    get isDisabled(){
        return this._isDisabled;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports=ActionItemComponent;